export class UUIDDateAudit{ 
    id;
    createdAt;
    updatedAt;
    deletedAt;
}